import { useTranslation } from 'react-i18next';
import { brandAdvantages } from '@/mocks/homeData';

export default function BrandAdvantages() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            {t('advantages.title')}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            {t('advantages.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 max-w-5xl mx-auto">
          {brandAdvantages.map((adv) => (
            <div key={adv.id} className="text-center p-6 rounded-xl bg-background-50 hover:scale-[1.02] transition-all">
              <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-2xl bg-primary-100/70">
                <i className={`${adv.icon} text-primary-500 text-2xl`}></i>
              </div>
              <h3 className="font-semibold text-foreground-950 mb-2">{adv.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{adv.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}